// Firestore functions and database instance
import { db } from "../firebase"; // Import Firestore database instance
import { collection, addDoc, serverTimestamp } from "firebase/firestore"; // Firestore functions

/**
 * Custom hook to handle adding a comment to Firestore
 */
const useAddComment = () => {
  /**
   * Function to add a new comment to Firestore 'comments' collection
   * @param {Object} commentData - Should include:
   *   - newsId: ID or link of the news article
   *   - text: Comment content
   *   - name: Name of the commenter
   */
  const addComment = async ({ newsId, text, name }) => {
    // Validate input: exit early if any required field is missing
    if (!text || !newsId || !name) return;

    try {
      // Add a new document to 'comments' collection
      await addDoc(collection(db, "comments"), {
        newsId,               // Link the comment to a specific news article
        text,                 // The actual comment content
        name,                 // Name of the commenter (stored for reuse)
        moderated: true,     // No Moderation when set to true
        timestamp: serverTimestamp(), // Firestore server timestamp for sorting & display
      });
    } catch (error) {
      // Log error if adding fails
      console.error("Error adding comment:", error);
    }
  };

  // Return the addComment function so other components can use it
  return addComment;
};

export default useAddComment;
